module.exports = __webpack_public_path__ + "img/logo-cabana-carreiras.c0012ffe.svg";